module.exports = __webpack_public_path__ + "img/selected7-min.d07d12d5.png";